import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "../../../environments/environment";

@Injectable()
export class HttpService {
  baseUrl: string;

  constructor(public http: HttpClient) {
    this.baseUrl = environment.API_URL;
  }

  get(
    url: string,
    params?: {
      [param: string]: string | string[];
    },
    acceptLanguage?: string,
    responseType?: XMLHttpRequestResponseType,
    octet_stream?: any,
  ): Observable<any> {
    let options: any = {};
    if (params) {
      options.params = params;
    }

    if (acceptLanguage) {
      options.headers = new HttpHeaders().set(
        "Accept-Language",
        acceptLanguage,
      );
    }
    if (responseType) {
      options.responseType = responseType;
    }
    if (octet_stream) {
      options.headers = new HttpHeaders().set("Accept", "*/*");
      options.reportProgress = true;
    }

    return this.http.get(this.baseUrl + url, options);
  }

  getBlob(url: string): Observable<Blob> {
    return this.http.get(this.baseUrl + url, {
      responseType: "blob" as const,
    });
  }

  post(
    url: string,
    data: any,
    params?: {
      [param: string]: string | string[];
    },
    responseType?: XMLHttpRequestResponseType,
    multipart?: any,
    language?: any,
  ): Observable<any> {
    let options: any = {};
    if (params) {
      options.params = params;
    }
    if (responseType) {
      options.responseType = responseType;
    }
    if (multipart) {
      //options.headers = new HttpHeaders().set('Content-Type', 'multipart/form-data; boundary='); -> LO setta in automatico!
    } else {
      options.headers = new HttpHeaders().set(
        "Content-Type",
        "application/json",
      );
    }
    if (language) {
      options.headers = new HttpHeaders().set("Accept-Language", language);
    }
    return this.http.post(this.baseUrl + url, data, options);
  }

  postFormData(
    url: string,
    formData: FormData,
    params?: { [param: string]: string | string[] },
    language?: string,
  ): Observable<any> {
    const options: any = { params };

    let headers = new HttpHeaders();
    if (language) {
      headers = headers.set("Accept-Language", language);
    }

    options.headers = headers;

    return this.http.post(this.baseUrl + url, formData, options);
  }

  put(
    url: string,
    data: any,
    responseType?: XMLHttpRequestResponseType,
  ): Observable<any> {
    let options: any = {};
    if (responseType) {
      options.responseType = responseType;
    }
    options.headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.http.put(this.baseUrl + url, data, options);
  }

  delete(url: string, data?: any): Observable<any> {
    let options: any = {};
    if (data) {
      options.body = data;
    }
    return this.http.delete(this.baseUrl + url, options);
  }
}
